import React, { Component } from "react";
import Header from "./header";
import SidePanel from "./sidePanel";
import Dashboard from "./dashboard";
import Contract from "./Contract";

import Matrix from "./matrix";
import { ethers } from "ethers";
import getWallet, {disconnectWallet} from "../../services/wallet";
import withWrapper from "../../helpers/withWrapper";
import getContract from "../../services/contract";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Pools from "./Pools";

import { Flip, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BuyToken from "./BuyToken";
import Rewards from "./Rewards";

class DashboardLayout extends Component {
  constructor(props) {
    super(props);
    if (props.router.params.id > 0) {
      this.state.userId = props.router.params.id;
    } else {
      this.state.userId = 1;
    }
    // this.notify("Global Reward has no longer been accumulated, All new 10% distribution has been moving to BUSO treasury, But you can still claim");
  }

  state = {
    view: "dashboard",
    isViewMode: false,
    signer: null,
    userAddress: '',
    isSideBarOpen: false,
  };

  handleSetUserId = (id) => {
    this.setState({ userId: id });
  };

  connectWallet = async () => {
    const wallet = await getWallet();
    if (!wallet.isReadOnly) {
      const browserAddresses = await wallet.provider.listAccounts();
      this.setState({ signer: wallet.signer, userAddress: browserAddresses[0] });
      console.log("Wallet Connected");
    }
  };

  handleWalletConnected = async (contract) => {
    this.setState({ signer: contract.signer });
  };

  handleDisconnect = async () => {
    disconnectWallet();
    this.setState({ signer: null });
  }

  handleConnectWallet = async () => {
    await this.connectWallet();
  };

  handleDashboardClick = () => {
    this.props.router.navigate("/dashboard/" + this.state.userId);
    toast.dismiss();
    this.sideBarToggle();
  };

  handleLendClick = () => {
    this.props.router.navigate("/lend/" + this.state.userId);
    toast.dismiss();
    this.sideBarToggle();
  };

  handleBorrowClick = () => {
    this.props.router.navigate("/borrow/" + this.state.userId);
    toast.dismiss();
    this.sideBarToggle();
  };

  handleContractClick = () => {
    this.props.router.navigate("/contracts");
    toast.dismiss();
    this.sideBarToggle();
  };

  handleBuyTokenClick = () => {
    this.props.router.navigate("/buytoken");
    toast.dismiss();
    this.sideBarToggle();
  };

  handleRewardsClick = () => {
    this.props.router.navigate("/rewards");
    toast.dismiss();
    this.sideBarToggle();
  };

  handlePoolClick = () => {
    this.props.router.navigate('/giver-rewards/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  sideBarToggle = () => {
    this.setState({ isSideBarOpen: !this.state.isSideBarOpen });
  };

  handleNavigateToRegister = (userId) => {
    this.props.router.navigate("/joinref=" + userId);
  };

  handleToastError = (message) => {
    this.notify(message);
  };

  handleNavigateToLogin = () => {
    this.props.router.navigate("/login");
  };

  handleSetUserId = (id) => {
    this.setState({ userId: id });
  };

  handleSlotClick = (level) => {
    this.props.router.navigate("/dashboard/" + this.state.userId + "/" + level);
    this.setState({ level, view: "matrix" });
  };

  handleAutoRunClick = (userId) => {
    this.props.router.navigate("/autorun/" + userId);
    this.setState({ userId, view: "autorun" });
  };

  notify = (message) =>
    toast.error(message, {
      position: toast.POSITION.BOTTOM_LEFT,
      delay: "4000",
      style: { zIndex: "2" },
      transition: Flip,
      autoClose: 4000,
    });

  render() {
    return (
      <div id="__next1">
        <ToastContainer
          position="bottom-right"
          theme="colored"
          autoClose={1000}
        />
        <div
          className="relative flex bg-main-bg items-center justify-center min-h-screen min-w-full overflow-hidden"
          style={{ background: "rgba(112, 100, 0, 0.25)" }}
        >
          <Header
            onConnectWallet={this.handleConnectWallet}
            userAddress={this.state.userAddress}
            signer={this.state.signer}
            sideBarToggle={this.sideBarToggle}
            onDisconnect={this.handleDisconnect}
            // userAddress={this.state.userAddress}
          />
          <div className="flex w-full h-full justify-center max-w-desktop-full">
            <SidePanel
              onDashboardClick={this.handleDashboardClick}
              onPoolsClick={this.handlePoolClick} 
              id={this.state.userId}
              onLendClick={this.handleLendClick}
              onBorrowClick={this.handleBorrowClick}
              sideBarOpened={this.state.isSideBarOpen}
              onContractsClick={this.handleContractClick}
              onBuyTokenClick={this.handleBuyTokenClick}
              onRewardsClick={this.handleRewardsClick}
            
            />
            <Routes>
              <Route
                path="dashboard/:id"
                element={
                  <Dashboard
                    navigateToRegister={this.handleNavigateToRegister}
                    onSetUserId={(id) => this.handleSetUserId(id)}
                    onSlotClick={this.handleSlotClick}
                    onAutoRunClick={this.handleAutoRunClick}
                    onError={(message) => this.handleToastError(message)}
                    isViewMode={this.state.isViewMode}
                    userId={this.state.userId}
                    onWalletConnected={this.handleWalletConnected}
                  />
                }
              />
              {/* <Route path="giver-rewards/:id" element={<Pools 
                onSetUserId={(id) => this.handleSetUserId(id)}
                isViewMode={this.state.isViewMode}
                userId={this.state.userId}
                onWalletConnected={this.handleWalletConnected} />} 
              /> */}
              <Route
                path="dashboard/:id/:level"
                element={
                  <Matrix
                    onSetUserId={(id) => this.handleSetUserId(id)}
                    router={this.props.router}
                    level={this.state.level}
                    userId={this.state.userId}
                    idsOnLevel={this.state.idsOnLevel}
                  />
                }
              />
              
              <Route path="contracts" element={<Contract />} />
              <Route path="buytoken" element={<BuyToken />} />
              <Route path="rewards" element={<Rewards />} />
            </Routes>
          </div>
        </div>
      </div>
    );
  }
}

export default withWrapper(DashboardLayout);
